var map = {
	"./car.png": 11479,
	"./dollar.png": 29662,
	"./employee.png": 75019,
	"./money.png": 80880,
	"./no-emission.png": 71830,
	"./no-parking.png": 71317,
	"./save.png": 35613,
	"./social.png": 14110,
	"./stars.png": 75651,
	"./tree.png": 78301
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79046;